import { render, staticRenderFns } from "./ManagementControlCards.vue?vue&type=template&id=1720c1f3&scoped=true"
import script from "./ManagementControlCards.vue?vue&type=script&lang=js"
export * from "./ManagementControlCards.vue?vue&type=script&lang=js"
import style0 from "./ManagementControlCards.vue?vue&type=style&index=0&id=1720c1f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1720c1f3",
  null
  
)

export default component.exports